import { useQuery } from '@tanstack/react-query';

import { fetchMySignature } from './signatureApi';
import { signatureKeys } from './keys';

/** Read the clinician's saved signature (or the synthesized default).
 *  Always enabled -- the panel needs *something* to preview, and the
 *  endpoint is cheap (one row by clinician id, with a no-row fallback
 *  baked into the model layer).
 */
export function useSignatureQuery() {
  return useQuery({
    queryKey: signatureKeys.all,
    queryFn: ({ signal }: { signal?: AbortSignal }) => fetchMySignature(signal),
    meta: {
      toast: {
        title: 'Could not load signature',
        description:
          "We couldn't fetch your saved e-signature. Try again from the signature panel.",
      },
    },
  });
}
